// extracted by mini-css-extract-plugin
export default {"container":"styles_container__tANfU","title":"styles_title__jJ5Pn","description":"styles_description__hsB67","link":"styles_link__kyRZr"};